<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useKanbanTaskShowApi } from '../api/kanban-task-show.hook'
import { useTasksKanbanCommentsApi } from '../api/comments.hook'
import SectionTaskInfoUpdate from './SectionTaskInfoUpdate.vue'

defineOptions({
  name: 'TasksKanbanInfoPage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  const id = route.params.id
  if (typeof id !== 'string' || !id) return

  void useKanbanTaskShowApi({ id })
  void useTasksKanbanCommentsApi({ taskId: id })
})
</script>

<template>
  <SectionTaskInfoUpdate />
</template>
